import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import PhoneForwardedOutlinedIcon from '@mui/icons-material/PhoneForwardedOutlined';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import { Box, FormControl, Input, MenuItem, Modal, Select } from "@mui/material";
import Button from '@mui/material/Button';
import ButtonGroup from "@mui/material/ButtonGroup";
import IconButton from "@mui/material/IconButton";
import Popover from "@mui/material/Popover";
import Popper from "@mui/material/Popper";
import React, { useEffect, useReducer, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import USAFlag from "../../Assets/Images/Country-Icons/USA.svg";
import { copyToClipboard, notifyInAppError, notifyInAppSuccess } from "../../components/UtilitiesTS";
import { IUserDetails } from "../../interfaces/General";
import { TwilioConversationsRedux } from '../../redux/actions/TwilioConversations/TwilioConversations';
import { twilioConversationsConstants } from '../../redux/constants/TwilioConversationsConstant';
import { useAppDispatchTS } from '../../redux/hooksTS';
import TCUtilities from "./TwilioConversationUtilities";
import { validateNumber, validatePhoneNumber } from './TwilioModals';
interface TwilioNumberForwardingProps {
    advisor_or_staff_number: string;
    chatType: string;
    userDetails: IUserDetails;
}
 
const formatPhoneNumber = (phone: string) => {
    const digitsOnly = phone.replace(/\D/g, '');
    return `+${digitsOnly.slice(0, 1)} (${digitsOnly.slice(1, 4)}) ${digitsOnly.slice(4, 7)}-${digitsOnly.slice(7)}`;
};
 
const TwilioNumberForwarding: React.FC<TwilioNumberForwardingProps> = ({
    advisor_or_staff_number,
    chatType,
    userDetails
}) => {
    const navigate = useNavigate();
    const dispatch = useAppDispatchTS();
    // TODO: these are place holders to build Frontend of call forwarding, will ned to be replaced
    const [forwardingNumber, setForwardingNumber] = useState<boolean>(false);
    const [forwardingNumberAlert, setForwardingNumberAlert] = useState<boolean>(false);
    const [forwardingNumberAlertModal, setForwardingNumberAlertModal] = useState<boolean>(false);
    const [forwardingNumberValue, setForwardingNumberValue] = useState<string>(userDetails.twilio_call_forwarding_number || "+1 (000) 000-0000");
    const [forwardingNumberValueTemp, setForwardingNumberValueTemp] = useState<string>("");
    const [forwardingNumberValuePlaceholder, setForwardingNumberValuePlaceholder] = useState<string>("");
    const [advisorNumberPopup, setAdvisorNumberPopup] = useState<boolean>(false);
    const [forwardingNumberPopup, setForwardingNumberPopup] = useState<boolean>(false);
    const [forwardingNumberCountryCode, setForwardingNumberCountryCode] = useState<string>("+1");
    const [textAccessRequestModal, setTextAccessRequestModal] = useState<boolean>(false);
    const callForwardingButton = useRef<HTMLDivElement>(null);
 
    const [, forceUpdate] = useReducer(x => x + 1, 0);
 
    const handleNumberSave = (forwardingNumberCountryCode: string, forwardingNumberValueTemp: string) => {
        try {
            if (forwardingNumberValueTemp.length === 0) {
                // Allow users to remove their call forwarding number
                dispatch(TwilioConversationsRedux.UpdateCallForwardingNumber("", userDetails.twilio_conversations_user_identity)).then((response: any) => {
                    if (response.type === twilioConversationsConstants.UPDATE_CALL_FORWARDING_NUMBER_SUCCESS) {
                        notifyInAppSuccess("Call forwarding number removed successfully");
                        setForwardingNumberPopup(false);
                        setAdvisorNumberPopup(false);
                        setForwardingNumber(false);
                        setForwardingNumberAlert(false);
                        setForwardingNumberAlertModal(false);
                        setForwardingNumberValue('');
                        userDetails.twilio_call_forwarding_number = '';
                        localStorage.setItem("userDetails", JSON.stringify(userDetails));
                    } else {
                        notifyInAppError("Failed to remove call forwarding number");
                    }
                });
            } else if (validatePhoneNumber(forwardingNumberValueTemp)) {
                setForwardingNumber(true);
                setForwardingNumberPopup(false);
                setAdvisorNumberPopup(false)
                setForwardingNumberValue(formatPhoneNumber(forwardingNumberCountryCode + forwardingNumberValueTemp));
 
                dispatch(TwilioConversationsRedux.PostValidateLegitimacyOfPhoneNumber(forwardingNumberCountryCode + forwardingNumberValueTemp)).then((response: any) => {
                    if (response.type === twilioConversationsConstants.POST_VALIDATE_LEGITIMACY_OF_PHONE_NUMBER_SUCCESS) {
                        console.log("Successfully validated phone number: ", response.data);
                        dispatch(TwilioConversationsRedux.UpdateCallForwardingNumber(forwardingNumberCountryCode + forwardingNumberValueTemp, userDetails.twilio_conversations_user_identity)).then((response: any) => {
                            if (response.type === twilioConversationsConstants.UPDATE_CALL_FORWARDING_NUMBER_SUCCESS) {
                                notifyInAppSuccess("Call forwarding number updated successfully");
                                // Update userDetails with new call forwarding number since we don't store userDetails in Redux yet
                                userDetails.twilio_call_forwarding_number = forwardingNumberCountryCode + forwardingNumberValueTemp;
                                localStorage.setItem("userDetails", JSON.stringify(userDetails));
                                setForwardingNumberValue(formatPhoneNumber(userDetails.twilio_call_forwarding_number));
                            } else {
                                notifyInAppError("Failed to update call forwarding number");
                            }
                        });
                    } else {
                        // NOTE: Currently only US numbers are supported. See twilio_conversations_validate_legitimacy_of_phone_number() on BE for more details.
                        notifyInAppError("Failed to validate phone number: " + "Number is not a US number");
                    }
                });
            } else {
                setForwardingNumberValueTemp('');
                notifyInAppError("Please enter a valid phone number");
            }
        } catch (error) {
            notifyInAppError("Failed to update call forwarding number: " + JSON.stringify(error));
        }
    }
 
    useEffect(() => {
        // Check if userDetails has a call forwarding number
        if (userDetails.twilio_call_forwarding_number !== null && userDetails.twilio_call_forwarding_number !== "") {            
            setForwardingNumber(true);
            setForwardingNumberAlert(false);
            setForwardingNumberAlertModal(false);
            setForwardingNumberValue(formatPhoneNumber(userDetails.twilio_call_forwarding_number));
            setForwardingNumberValuePlaceholder(userDetails.twilio_call_forwarding_number.replace('+1', ''));
            setForwardingNumberValueTemp(userDetails.twilio_call_forwarding_number.replace('+1', '').replace('(', '').replace(')', '').replace(' ', '-'));
        } else {
            setForwardingNumberValuePlaceholder('000-000-0000');
            if (!forwardingNumber) {
                if (userDetails.twilio_assigned_proxy_number !== null && userDetails.twilio_assigned_proxy_number !== "") {
                    setForwardingNumber(false);
                    setForwardingNumberAlertModal(true);
                } else {
                    setTextAccessRequestModal(true);
                }
            } else {
                setForwardingNumber(true);
                setForwardingNumberAlert(false);
                setTextAccessRequestModal(false);
                setForwardingNumberAlertModal(false);
                console.log(forwardingNumberValue);
               
            }
        }
    }, [forwardingNumberValue]);
 
    useEffect(() => {
        console.log("Rerendering TwilioNumberForwarding component");
        console.log("chatType: ", chatType);
        console.log("advisor_or_staff_number: ", advisor_or_staff_number);
       
        forceUpdate();
    }, [chatType, advisor_or_staff_number]);
 
    useEffect(() => {
        if (!forwardingNumberAlertModal && !forwardingNumber && (userDetails.twilio_call_forwarding_number === null || userDetails.twilio_call_forwarding_number === "")) {
            const timer = setTimeout(() => {
                setForwardingNumberAlert(true);
            }, 2000);
 
            return () => clearTimeout(timer);
        }
    }, [forwardingNumberAlertModal]);
 
    return (
        <>
            {chatType === "text" && (
                <>
                    <ButtonGroup aria-label="Call Forwarding" className="advisor-number-selector" ref={callForwardingButton}>
                        <IconButton className="advisor-number-selector-button-current" disableRipple onClick={() => { setAdvisorNumberPopup(true) }}>
                            <PhoneOutlinedIcon />
                        </IconButton>
                        <IconButton
                            className={`advisor-number-selector-button-forward ${!forwardingNumber ? 'error' : ''}`}
                            disableRipple
                            onClick={() => { setForwardingNumberPopup(true) }}
                        >
                            <PhoneForwardedOutlinedIcon />
                            <EditOutlinedIcon fontSize="small" className="forwarding-number-edit-icon" />
                        </IconButton>
                    </ButtonGroup>
                    <Popper
                        modifiers={[
                            {
                                name: 'preventOverflow',
                                enabled: true,
                                options: {
                                    altAxis: true,
                                    altBoundary: true,
                                    tether: false,
                                    rootBoundary: 'document',
                                    padding: 8,
                                },
                            },
                        ]}
                        open={forwardingNumberAlert}
                        anchorEl={callForwardingButton.current}
                        placement="right"
                        className="advisor-number-popup-alert"
                    >
                        <div className="advisor-number-popup-alert-inner">
                            <div className="advisor-number-popup-alert-inner-text">
                                <p>Reminder to set up your call forwarding </p>
                            </div>
                            <div className="advisor-number-popup-alert-close-button">
                                <IconButton className="advisor-number-popup-alert-close-button-icon" disableRipple onClick={() => { setForwardingNumberAlert(false) }}>
                                    <CloseOutlinedIcon fontSize="small" style={{ color: "#DC0101" }} />
                                </IconButton>
                            </div>
                        </div>
                    </Popper>
                    <Popover
                        anchorOrigin={{
                            vertical: 'center',
                            horizontal: 'center',
                        }}
                        transformOrigin={{
                            vertical: 'center',
                            horizontal: 'center',
                        }}
                        open={advisorNumberPopup}
                        anchorEl={callForwardingButton.current}
                        onClose={() => { setAdvisorNumberPopup(false) }}
                        className="advisor-number-popup"
                    >
                        <div className="advisor-number-popup-inner">
                            <div className="d-flex align-items-center pb-8">
                                <PhoneOutlinedIcon />
                                <button className="mx-16 button-clear fw-bold" onClick={() => { copyToClipboard(TCUtilities.formatPhoneNumber(advisor_or_staff_number)) }}>
                                    {TCUtilities.formatPhoneNumber(advisor_or_staff_number)}
                                </button>
                                <span className="edit-icon" style={{ color: "#D9D9D9", display: 'block' }} data-text="Moneta Central Number">
                                    <InfoOutlinedIcon fontSize="small" />
                                </span>
                            </div>
                            <div className={`d-flex align-items-center pt-8 ${!forwardingNumber ? 'error' : ''}`}>
                                <PhoneForwardedOutlinedIcon />
                                <button className="mx-16 button-clear" onClick={() => { copyToClipboard(forwardingNumberValue) }}>
                                    {forwardingNumberValue !== "" ? forwardingNumberValue : "+0 000-000-0000"}
                                </button>
                                <IconButton title="Edit Call Forwarding Number" className="edit-icon" disableRipple onClick={() => { setForwardingNumberPopup(true) }} style={{ color: "#D9D9D9", marginRight: '4px' }}>
                                    <EditOutlinedIcon fontSize="small" />
                                </IconButton>
                                <span className="edit-icon" style={{ color: "#D9D9D9", display: 'block' }} data-text="Call Forwarding Number">
                                    <InfoOutlinedIcon fontSize="small" />
                                </span>
                            </div>
 
 
                        </div>
                    </Popover>
                    <Modal
                        open={textAccessRequestModal}
                        onClose={() => {
                            navigate("/dashboard");
                            setTextAccessRequestModal(false);
                        }}
                        className="forwarding-number-popup"
                    >
                        <Box>
                            <div className="forwarding-number-popup-close">
                                <IconButton className="" disableRipple onClick={() => {
                                    navigate("/dashboard");
                                    setTextAccessRequestModal(false);
                                }}>
                                    <CancelOutlinedIcon style={{ color: "#E6A636" }} />
                                </IconButton>
                            </div>
                            <div className="forwarding-number-popup-header">
                                <InfoOutlinedIcon className="forwarding-number-popup-header-icon" fontSize="large" style={{ color: "#E6A636" }} />
                                <h2 className="text-center"><em>You are not currently enrolled in texting. Click below to enter a help desk ticket to obtain a number.</em></h2>
                            </div>
                            <Button
                                className="forwarding-number-popup-button"
                                variant="contained"
                                color="primary"
                                href="https://mgitmanage2.monetagroup.com/"
                                target="_blank"
                            >
                                SUBMIT A HELPDESK TICKET
                            </Button>
                        </Box>
                    </Modal>
                    <Modal
                        open={forwardingNumberAlertModal}
                        onClose={() => {
                            setForwardingNumberAlertModal(false);
                        }}
                        className="forwarding-number-popup"
                    >
                        <Box>
                            <div className="forwarding-number-popup-close">
                                <IconButton className="" disableRipple onClick={() => { setForwardingNumberAlertModal(false) }}>
                                    <CancelOutlinedIcon style={{ color: "#E6A636" }} />
                                </IconButton>
                            </div>
                            <div className="forwarding-number-popup-header">
                                <PhoneForwardedOutlinedIcon className="forwarding-number-popup-header-icon" fontSize="large" style={{ color: "#E6A636" }} />
                                <h2 className="text-center"><em>Please set up your call forwarding. You can click below or edit at any time in the top left corner.</em></h2>
                            </div>
                            <Button
                                className="forwarding-number-popup-button"
                                variant="contained"
                                color="primary"
                                onClick={() => {
 
                                    setForwardingNumberPopup(true);
                                }}
                            >
                                SET UP
                            </Button>
                        </Box>
                    </Modal>
 
                    <Modal
                        className="forwarding-number-popup"
                        open={forwardingNumberPopup}
                        onClose={() => { setForwardingNumberPopup(false); setAdvisorNumberPopup(false) }}
                    >
                        <Box>
                            <div className="forwarding-number-popup-header border-bottom d-flex align-items-center justify-content-between">
                                <h3>Call Forwarding </h3>
                                <IconButton className="forwarding-number-popup-close-button" disableRipple onClick={() => { setForwardingNumberPopup(false); setAdvisorNumberPopup(false) }}>
                                    <CancelOutlinedIcon style={{ color: "#E6A636" }} />
                                </IconButton>
                            </div>
                            <div className="forwarding-number-popup-body">
                                <p className="mb-4">
                                    Forward to
                                </p>
                                <div className="forwarding-number-popup-input-container d-flex align-items-center">
                                    <FormControl>
                                        <Select
                                            variant="standard"
                                            disableUnderline
                                            onChange={(event) => {
                                                setForwardingNumberCountryCode(event.target.value)
                                            }}
                                            defaultValue={forwardingNumberCountryCode}
                                            autoWidth
                                        >
                                            <MenuItem value={'+1'}><img width="20px" src={USAFlag} alt="US" /></MenuItem>
                                        </Select>
                                    </FormControl>
 
                                    <div className="forwarding-number-popup-input-container-country-code mx-8">
                                        {forwardingNumberCountryCode}
                                    </div>
                                    <Input
                                        placeholder={forwardingNumberValuePlaceholder}
                                        value={forwardingNumberValueTemp}
                                        disableUnderline
                                        onChange={(event) => {
                                            if (validateNumber(event.target.value)) {
                                                setForwardingNumberValueTemp(event.target.value)
                                            } else {
                                                setForwardingNumberValueTemp('')
                                                notifyInAppError("Please enter a valid phone number");
                                            }
                                        }}
                                        onKeyDown={(event) => {
                                            if (event.key === 'Enter') {
                                                handleNumberSave(forwardingNumberCountryCode, forwardingNumberValueTemp);
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="forwarding-number-popup-footer">
                                <Button
                                    className="forwarding-number-popup-button"
                                    variant="contained"
                                    color="primary"
                                    onClick={() => {
                                        handleNumberSave(forwardingNumberCountryCode, forwardingNumberValueTemp);
                                    }}>
                                    Save
                                </Button>
                                <div className="mb-0 mt-16 text-center relative flex justify-content-center align-items-center call-forward-notice-icon" data-text="If you are forwarding RingCentral to your cell phone, please also forward Moneta Central to your cell phone to avoid call failure."><InfoOutlinedIcon className="me-6" style={{ color: "#E6A636" }} fontSize="small" /> <span className="fw-bold">Notice:</span><span>&nbsp;Chain forwarding is not supported</span></div>
                            </div>
                        </Box>
                    </Modal>
                </>
            )}
        </>
    );
};
 
export default TwilioNumberForwarding;